export default "__VITE_ASSET__BgDzBc7q__"